'use client'

import { SessionProvider } from 'next-auth/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { getQueryClient } from '@lib/query-client'
import TelegramMiniAppAuth from '@modules/account/components/telegram-miniapp-auth'

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient()

  return (
    <SessionProvider refetchOnWindowFocus={true} refetchWhenOffline={false}>
      <QueryClientProvider client={queryClient}>
        <TelegramMiniAppAuth />
        {children}
      </QueryClientProvider>
    </SessionProvider>
  )
}
